import { SidebarMenu } from "../../../ui/sidebar.js"
import { SidebarCollapsibleItem } from "./sidebar-collapsible-item.js"
import { SidebarMenuItem } from "./sidebar-menu-item.js"

/**
 * Lista de itens do menu principal da sidebar.
 */
export function SidebarMenuList({
  items,
  collapsed,
  isMobile,
  isPathActive,
  isSectionOpen,
  onSectionOpenChange,
  onNavigate,
  onActiveMenuChange,
}) {
  return (
    <SidebarMenu className="flex flex-col gap-1">
      {items.map((item) => {
        if (item.children?.length) {
          const sectionOpen = isSectionOpen(item)
          const hasActiveChild = item.children.some((child) =>
            isPathActive(child.href),
          )

          return (
            <SidebarCollapsibleItem
              key={item.id}
              item={item}
              collapsed={collapsed}
              isMobile={isMobile}
              sectionOpen={sectionOpen}
              hasActiveChild={hasActiveChild}
              onOpenChange={(open) => onSectionOpenChange(item, open)}
              isPathActive={isPathActive}
              onNavigate={onNavigate}
              onActiveMenuChange={onActiveMenuChange}
            />
          )
        }

        return (
          <SidebarMenuItem
            key={item.id}
            item={item}
            collapsed={collapsed}
            isMobile={isMobile}
            isActive={isPathActive(item.href)}
            onNavigate={onNavigate}
            onActiveMenuChange={onActiveMenuChange}
          />
        )
      })}
    </SidebarMenu>
  )
}
